import { render, staticRenderFns } from "./WorkIconNavProduct.vue?vue&type=template&id=0d7b2238"
import script from "./WorkIconNavProduct.vue?vue&type=script&lang=js"
export * from "./WorkIconNavProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports